import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SelectedRadioButton(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <Path
                d="M10 14.65c1.3 0 2.4-.45 3.3-1.35.9-.9 1.35-2 1.35-3.3 0-1.3-.45-2.4-1.35-3.3-.9-.9-2-1.35-3.3-1.35-1.3 0-2.4.45-3.3 1.35-.9.9-1.35 2-1.35 3.3 0 1.3.45 2.4 1.35 3.3.9.9 2 1.35 3.3 1.35zM10 20a9.676 9.676 0 01-3.875-.788 10.144 10.144 0 01-3.188-2.15 10.142 10.142 0 01-2.15-3.187A9.676 9.676 0 010 10c0-1.383.263-2.683.787-3.9a9.994 9.994 0 012.15-3.175A10.25 10.25 0 016.126.788 9.676 9.676 0 0110 0c1.383 0 2.683.263 3.9.787a10.098 10.098 0 013.175 2.138c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0120 10a9.676 9.676 0 01-.788 3.875 10.25 10.25 0 01-2.137 3.188 9.994 9.994 0 01-3.175 2.15A9.738 9.738 0 0110 20zm0-1.5c2.367 0 4.375-.83 6.025-2.488C17.675 14.354 18.5 12.35 18.5 10c0-2.367-.825-4.375-2.475-6.025C14.375 2.325 12.367 1.5 10 1.5c-2.35 0-4.354.825-6.013 2.475C2.33 5.625 1.5 7.633 1.5 10c0 2.35.83 4.354 2.487 6.012C5.646 17.671 7.65 18.5 10 18.5z"
                fill="#2D57D9"
            />
        </Svg>
    )
}

export default SelectedRadioButton
